<template>
  <div class="flex gap-2 w-full overflow-hidden" @click="$emit('click')">
    <div class="w-25 h-25 flex-shrink-0 flex justify-center items-center">
      <AppEventLogo v-if="pokerRunEvent" :is-small="true" :event-id="pokerRunEvent?.id"
        :event-image="pokerRunEvent?.eventSettings?.eventImage" />
    </div>

    <div v-if="pokerRunEvent" class="flex-grow min-w-0 pt-[10px]">
      <div class="flex items-center gap-4 w-full overflow-hidden">
        <h3 class="text-normal-emphasis font-bold truncate max-w-full">
          {{ pokerRunEvent?.name }}
        </h3>
      </div>


      <div class="text-sm text-normal-standard font-medium truncate">
        {{ formatEventDate }}
      </div>

      <div  v-if="pokerRunEvent?.eventType"class="text-sm text-normal-standard font-medium truncate">
        {{ pokerRunEvent?.eventType }}
      </div>

      <div v-if="isRegistered" class="inline-flex items-center px-2.5 py-0.5 bg-blue-100 text-blue-800 text-xs font-medium rounded-full ">
        <i class="fas fa-check-circle mr-1"></i>
        Registered
      </div>

      <div v-if="pokerRunEvent?.eventSettings?.isPrivateEvent && showDetails"
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
        <i class="fas fa-lock mr-1"></i>
        Private Event
      </div>

      <div v-if="!hasRegistrationDatePast(pokerRunEvent) && showDetails" class="text-sm text-normal-reduced truncate">
        Registration Opens {{ getDate(pokerRunEvent?.eventSettings?.registrationStartDate) }}
      </div>

      <div v-else-if="showDetails" class="text-sm text-normal-reduced truncate">
        {{ getHandsSoldDisplay(pokerRunEvent) }}
      </div>

      <div v-if="showDetails" class="text-sm text-normal-reduced truncate">
        Dealt by: {{ getCardReleaseDisplay(pokerRunEvent) }}
      </div>

    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import Constants from "@/models/Constants";
import { PokerRunEvent } from "@models/PokerRunEvent";
import useDate from "@/modules/useDate";
import useEvent from "@/modules/useEvent";

const { getDateTime, getDate, formatFullDatetime } = useDate();
const { hasRegistrationDatePast, getHandsSoldDisplay, getCardReleaseDisplay, isPastEvent } = useEvent();

const emit = defineEmits(['click']);
interface Props {
  pokerRunEvent: PokerRunEvent;
  showDetails?: boolean;
  isRegistered?: boolean;
}

const props = withDefaults(defineProps<Props>(),
  {
    showDetails: true,
  });

const eventDate = computed(() => getDate(props.pokerRunEvent?.eventDate as string));
const startTime = computed(() => {
  if (props.pokerRunEvent?.stops && props.pokerRunEvent?.stops[0]?.expectedArrivalTime) {
    const arrivalTime = props.pokerRunEvent.stops[0].expectedArrivalTime;
    if (arrivalTime && typeof arrivalTime === 'string') {
      const date = new Date(arrivalTime);
      return !isNaN(date.getTime()) ? date : getDateTime(props.pokerRunEvent?.eventDate as string);
    }
  }
  return getDateTime(props.pokerRunEvent?.eventDate as string);
});

const registrationFee = computed(() => {
  const item = props.pokerRunEvent?.lineItems?.find(
    (i) => i.itemType === Constants.FEE_TYPE
  );
  if (item) {
    return item;
  }
  return null;
});

const formatEventDate = computed(() => {
  if (!startTime.value) return '';
  return formatFullDatetime(startTime.value);
});
</script>
